import AbstractCommand from "../../../core/application/AbstractCommand";
import SkinKeyRegistry from "../../../core/ui/SkinKeyRegistry";
import SaveGameModel from "../model/SaveGameModel";
import SaveGameService from "./SaveGameService";

export default class ShowPendingGameSavedFeedbackCommand extends AbstractCommand {
    /**
     * @constructor
     * @param {soma.EventDispatcher} dispatcher 
     * @param {SaveGameModel} saveGameModel 
     * @param {SaveGameService} saveGameService 
     */
    constructor(dispatcher, saveGameModel, saveGameService) {
        super(dispatcher);

        this._saveGameModel = saveGameModel;
        this._saveGameService = saveGameService;
    }

    async execute(evt) {
        if (!this._saveGameModel.gameSavedFeedbackPending) {
            return;
        }

        this._saveGameModel.gameSavedFeedbackPending = false;
        this.openPopup(SkinKeyRegistry.GAME_SAVED_NOTIFICATION_OVERLAY_SCREEN_SKIN, null, {
            needsOverlay: false,
            priority: 15,
        });
    }
}